import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MultishareHistoryComponent} from './multishare-history.component';
import {EffectsModule} from '@ngrx/effects';
import {MultishareHistoryEffects} from './multishare-history.effects';
import {StoreModule} from '@ngrx/store';
import {multishareHistoryFeatureKey, reducer} from './multishare-history.reducer';
import { MultishareHistoryEntryComponent } from './multishare-history-entry/multishare-history-entry.component';
import { MultishareHistoryTableComponent } from './multishare-history-table/multishare-history-table.component';
import { MultishareHistorySearchComponent } from './multishare-history-search/multishare-history-search.component';
import {SharedModule} from '../../shared.module';


@NgModule({
  declarations: [
    MultishareHistoryComponent,
    MultishareHistoryEntryComponent,
    MultishareHistoryTableComponent,
    MultishareHistorySearchComponent
  ],
  exports: [
    MultishareHistoryEntryComponent
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(multishareHistoryFeatureKey, reducer),
    EffectsModule.forFeature([MultishareHistoryEffects]),
    SharedModule,
  ]
})
export class MultishareHistoryModule {
}
